import { RootState } from '../redux';

export const selectReportsMeta = (state: RootState) => state.reports.reportsMeta;
export const selectModelsMeta = (state: RootState) => state.reports.modelsMeta;
